import { Button, Col, Drawer, Form, Row, Tooltip } from 'antd';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useOutletContext } from 'react-router-dom';
import { Cash, CloseIcon, Filter, HouseCertificate, Info, PieChart } from '../../../assets/icons';
import BankAccountModal from '../../../components/LinkBankAccount/BankAccountModal';
import TransactionItem from '../../../components/TransactionItem/TransactionItem';
import useGetUserProfile from '../../../Hooks/useGetUserProfile';
import { cancelTransfer, getAccountBalances, getTransactionsDetails } from '../../../services/AccountApi/balancesApi';
import { getFundingSources } from '../../../services/AccountApi/paymentMethodApi';
import { NOTIFICATION_MESSAGES } from '../../../utils/constant';
import { dateStringFormForFilter } from '../../../utils/setDateForFilter';
import { toastNotify } from '../../../utils/toastNotify';
import { getUsCurrencyFormat } from '../../../utils/usCurrencyFormatter';
import InitiateTransferModal from './InitiateTransferModal';
import ScheduledTransactionModal from './ScheduledTransactionModal';
import './Transaction.scss';
import TransactionDetailsModal from './TransactionDetailsModal';
import TransactionListFilter from './TransactionListFilter';
import TransferCompleteModal from './TransferCompleteModal';

const Transaction = () => {
  const [form] = Form.useForm();
  const { setLoading } = useOutletContext();
  const [accountBalances, setAccountBalances] = useState({ totalAccountValue: 0, investments: 0, cash: 0 });
  const [pendingTransferList, setPendingTransferList] = useState([]);
  const [failedTransList, setFailedTransList] = useState([]);
  const [scheduledTransferList, setScheduledTransferList] = useState([]);
  const [clearedTransferList, setClearedTransferList] = useState([]);
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false);
  const [transactionType, setTransactionType] = useState('All');
  const [timePeriod, setTimePeriod] = useState('');
  const [shareType, setShareType] = useState('All');
  const [tempFilterMobileObj, setTempMobileFilterObj] = useState({});
  const [transferModal, setTransferModal] = useState(false);
  const [pendingModalTransactionData, setPendingModalTransactionData] = useState({});
  const [scheduledModalTransactionData, setScheduledModalTransactionData] = useState({});
  const [transferCompleteModal, setTransferCompleteModal] = useState(false);
  const [transactionDetailsOpen, setTransactionDetailsOpen] = useState(false);
  const [scheduledOpen, setScheduledOpen] = useState(false);
  const [filterObj, setFilterObj] = useState({
    page: 1,
    perPage: 200,
    transactionType: '',
    toDate: '',
    fromDate: '',
    shareType: '',
  });
  const search = useLocation().search;
  const openTransection = new URLSearchParams(search).get('openTransection');
  const transactionsType = new URLSearchParams(search).get('transactionsType');
  const [, setTotalPage] = useState(0);
  const [initiateTransferedData, setInitiateTransferedData] = useState({});
  const [isBankInFundingSource, setIsBankInFundingSource] = useState(false);
  const [bankModalOpen, setBankModalOpen] = useState(false);
  const [cancelOrderLoading, setCancelOrderLoading] = useState(false);
  const userData = useSelector((state) => state.userData);

  useGetUserProfile();

  useEffect(() => {
    if (openTransection) {
      setTransferModal(true);
    }
  }, [openTransection]);

  // const counter = useSelector((state) => state.userData.counter);
  // function for handle modal
  const handleModalForPendingTransaction = (data) => {
    setPendingModalTransactionData(data);
    setTransactionDetailsOpen(true);
  };
  const handleModalForScheduledTransaction = (data) => {
    setScheduledModalTransactionData(data);
    setScheduledOpen(true);
  };
  //handle filter
  const handleTimePeriodFilter = (dayCount, fetchFromApi) => {
    !fetchFromApi && setTempMobileFilterObj({ shareType, timePeriod, transactionType });
    setTimePeriod(dayCount);
    form.setFieldsValue({ timePeriod: dayCount });
    const tempFilterObj = {
      ...filterObj,
      toDate: dateStringFormForFilter(0),
      fromDate: dateStringFormForFilter(dayCount === 'custom' ? 365 : dayCount),
    };
    setFilterObj(tempFilterObj);
    fetchFromApi && fetchTransactionsDetails(tempFilterObj);
  };
  const handleTransactionTypeFilter = (type, fetchFromApi) => {
    !fetchFromApi && setTempMobileFilterObj({ shareType, timePeriod, transactionType });
    setTransactionType(type);
    form.setFieldsValue({ transactionType: type });
    const tempFilterObj = { ...filterObj, transactionType: type === 'All' ? '' : type };
    setFilterObj(tempFilterObj);
    fetchFromApi && fetchTransactionsDetails(tempFilterObj);
  };
  const handleShareTypeFilter = (type, fetchFromApi) => {
    !fetchFromApi && setTempMobileFilterObj({ shareType, timePeriod, transactionType });
    form.setFieldsValue({ shareType: type });
    setShareType(type);
    const tempFilterObj = { ...filterObj, shareType: type === 'All' ? '' : type };
    setFilterObj(tempFilterObj);
    fetchFromApi && fetchTransactionsDetails(tempFilterObj);
  }; // handle mobile drawer
  const handleDrawerFilter = () => {
    setFilterDrawerOpen(false);
    fetchTransactionsDetails(filterObj);
  };
  const closeFilterDrawer = () => {
    setFilterDrawerOpen(false);
    setShareType(tempFilterMobileObj.shareType);
    setTransactionType(tempFilterMobileObj.transactionType);
    setTimePeriod(tempFilterMobileObj.timePeriod);
    form.setFieldsValue({ ...tempFilterMobileObj });
  };
  const handleInitiateTransfer = (val) => {
    if (!userData?.userData?.isDwollaVerified) {
      toastNotify('error', NOTIFICATION_MESSAGES.WARN_DWOLLA_PENDING);
      return;
    }

    if (val) {
      setTransferModal(true);
    } else {
      userData?.userData?.isKYCVerified
        ? setBankModalOpen(true)
        : !userData?.userData?.isKYCVerified
        ? toastNotify('error', 'Please complete all your verification steps first.')
        : toastNotify('error', 'Your account is still in-review, you will be informed after completion of your account review.');
    }
  };
  const handleBankAddSuccess = () => {
    setBankModalOpen(false);
    setIsBankInFundingSource(true);
    setTransferModal(true);
  };
  //API Integration functions
  const fetchAccountBalances = async () => {
    // TODO:
    if (userData?.userData?.isKYCVerified && userData?.userData?.isDwollaVerified) {
      try {
        const balanceResp = await getAccountBalances();
        const balanceData = balanceResp.data;
        if (!balanceResp.isError) {
          setAccountBalances(balanceData);
        } else {
          toastNotify('error', balanceResp?.message);
        }
      } catch (error) {
        const { response } = error;
        toastNotify('error', response?.data?.message);
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };
  const fetchTransactionsDetails = async (filters) => {
    setLoading(true);
    try {
      const transactionResp = await getTransactionsDetails(filters);
      const transactionData = transactionResp.data;
      if (!transactionResp.isError) {
        setTotalPage(transactionData.totalPage);
        setPendingTransferList(() => transactionData?.transactions?.filter((data) => data.status === 'Pending'));
        setClearedTransferList(() => transactionData?.transactions?.filter((data) => data.status === 'Completed'));
        setScheduledTransferList(() => transactionData?.transactions?.filter((data) => data.status === 'Scheduled'));
        setFailedTransList(() => transactionData?.transactions?.filter((data) => data?.status === 'Failed' || data?.status === 'Cancelled') ?? []);
        setCancelOrderLoading(false);
      } else {
        toastNotify('error', transactionResp.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handlecancelTransfer = async () => {
    setCancelOrderLoading(true);
    try {
      const cancelTransactionResp = await cancelTransfer(scheduledModalTransactionData?.id);
      if (!cancelTransactionResp.isError) {
        fetchTransactionsDetails(filterObj);
      } else {
        toastNotify('error', cancelTransactionResp.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    } finally {
      setCancelOrderLoading(false);
      setScheduledOpen(false);
    }
  };
  const getFundingSourcesFun = async () => {
    try {
      const resp = await getFundingSources();
      if (!resp.isError) {
        const { banks } = resp.data;
        setIsBankInFundingSource(banks.length > 0);
      } else {
        toastNotify('error', resp?.message);
      }
    } catch (error) {
      const { response } = error;
      toastNotify('error', response?.data?.message);
    }
  };
  useEffect(() => {
    if (!transferCompleteModal) {
      setLoading(true);
      fetchAccountBalances();
      transactionsType && setFilterObj({ ...filterObj, transactionType: 'Dividend' });
      transactionType && setTransactionType('Dividend');
      transactionsType ? fetchTransactionsDetails({ ...filterObj, transactionType: 'Dividend' }) : fetchTransactionsDetails(filterObj);
    }
  }, [transferCompleteModal, transactionsType]);
  useEffect(() => {
    getFundingSourcesFun();
    setTempMobileFilterObj({ shareType, timePeriod, transactionType });
  }, [filterDrawerOpen]);

  return (
    <div className='transaction'>
      {scheduledTransferList.length !== 0 && (
        <div className='p-24 mb-40 radius-4 transaction__items transaction__items--scheduled'>
          <p className='subhead-3 mb-0 text-terracotta'>Scheduled transfers</p>
          {scheduledTransferList.map((transaction) => {
            return <TransactionItem key={transaction.id} transaction={transaction} action={handleModalForScheduledTransaction} />;
          })}
        </div>
      )}
      <h4 className='mb-24 transaction__title'>Account Balances</h4>
      <div className='transaction__overview overview'>
        <div className='overview-card card'>
          <div className='card__icon'>
            <PieChart verticalAlign='middle' />
          </div>
          <div className='card__content'>
            <p className='card__content__title'>Net Account Value</p>
            <p className='subhead-1 card__content__number'>${getUsCurrencyFormat(accountBalances.totalAccountValue)}</p>
            <div className='card__content__action text-taupe-80'>
              Shares and cash
              <Tooltip
                title={
                  <>
                    <p>
                      Your total account value comprises the current total value of all property shares you own and your current cash balance. Bank
                      transfers may take 2 to 5 business days to complete, but the exact timing depends on your bank.
                    </p>
                  </>
                }
              >
                {' '}
                <Info size='16' verticalAlign='-3px' />{' '}
              </Tooltip>
            </div>
          </div>
        </div>
        <div className='overview-card card'>
          <div className='card__icon'>
            <HouseCertificate verticalAlign='middle' />
          </div>
          <div className='card__content'>
            <p className='card__content__title'>Investments</p>
            <p className='subhead-1 card__content__number'>${getUsCurrencyFormat(accountBalances.investments)}</p>
            <div className='card__content__action text-taupe-80'>All share types</div>
          </div>
        </div>
        <div className='overview-card card'>
          <div className='card__icon'>
            <Cash verticalAlign='middle' />
          </div>
          <div className='card__content'>
            <p className='card__content__title'>Cash</p>
            <p className='subhead-1 card__content__number'>${getUsCurrencyFormat(accountBalances.cash)}</p>
            <div className='card__content__action text-copper cursor-pointer large' onClick={() => handleInitiateTransfer(isBankInFundingSource)}>
              Transfer
            </div>
          </div>
        </div>
      </div>
      <div className='transaction__header'>
        <h4>Transactions</h4>
        {(!(clearedTransferList.length === 0 && pendingTransferList.length === 0 && failedTransList.length === 0) ||
          !!transactionType ||
          !!timePeriod ||
          !!shareType) && (
          <p className='cursor-pointer filter-trigger' onClick={() => setFilterDrawerOpen(true)}>
            <Filter verticalAlign='-7px' /> <span className='fw-600'>Filters</span> <span>({!!transactionType + !!timePeriod + !!shareType})</span>{' '}
          </p>
        )}
      </div>
      {clearedTransferList.length === 0 &&
        pendingTransferList.length === 0 &&
        failedTransList.length === 0 &&
        !(!!transactionType || !!timePeriod || !!shareType) && (
          <div className='nodata'>
            <p className='subhead-3 mb-4'>No transactions found</p>
            <p className='mb-0'>Pending and completed transactions will appear here</p>
          </div>
        )}
      {(!(clearedTransferList.length === 0 && pendingTransferList.length === 0 && failedTransList.length === 0) ||
        !!transactionType ||
        !!timePeriod ||
        !!shareType) && (
        <div className='mb-16 transaction__filters'>
          <Form form={form}>
            <Row gutter={16}>
              <Col span={8}>
                <TransactionListFilter
                  filterValue={transactionType}
                  action={(val) => handleTransactionTypeFilter(val, true)}
                  defaultValue={transactionsType ? 'Dividend' : transactionType}
                  label={'Transaction type'}
                  filterType={'transactionType'}
                />
              </Col>
              <Col span={8}>
                <TransactionListFilter
                  filterValue={timePeriod}
                  action={(val) => handleTimePeriodFilter(val, true)}
                  label={'Time period'}
                  filterType={'timePeriod'}
                />
              </Col>
              <Col span={8}>
                <TransactionListFilter
                  filterValue={shareType}
                  action={(val) => handleShareTypeFilter(val, true)}
                  label={'Share type'}
                  filterType={'shareType'}
                  defaultValue={shareType}
                />
              </Col>
            </Row>
          </Form>
        </div>
      )}
      {clearedTransferList.length === 0 &&
        pendingTransferList.length === 0 &&
        failedTransList.length === 0 &&
        (!!transactionType || !!timePeriod || !!shareType) && (
          <div className='nodata'>
            <p className='subhead-3 mb-4'>No transactions found</p>
            <p className='mb-0'>Applied filters have no transactions</p>
          </div>
        )}
      <div>
        {failedTransList.length !== 0 && (
          <div className=' mb-32 transaction__items'>
            <p className='subhead-3 mb-0'>Failed/Cancelled</p>
            {failedTransList.map((transaction) => {
              return <TransactionItem key={transaction.id} transaction={transaction} action={handleModalForPendingTransaction} />;
            })}
          </div>
        )}
        {pendingTransferList.length !== 0 && (
          <div className='mb-32 transaction__items'>
            <p className='subhead-3 mb-0'>
              Pending{' '}
              <Tooltip title="We authorized these transactions but they haven't been finalized yet, so they're not included in your current balances and/or owned assets.">
                {' '}
                <Info size='16' color='#726460' verticalAlign='-3px' />{' '}
              </Tooltip>
            </p>
            {pendingTransferList.map((transaction) => {
              return <TransactionItem key={transaction.id} transaction={transaction} action={handleModalForPendingTransaction} />;
            })}
          </div>
        )}
        {clearedTransferList.length !== 0 && (
          <div className='transaction__items'>
            <p className='subhead-3 mb-0'>Cleared</p>
            {clearedTransferList.map((transaction) => {
              return <TransactionItem key={transaction.id} transaction={transaction} action={handleModalForPendingTransaction} />;
            })}
          </div>
        )}
      </div>
      <Drawer
        className='filter-drawer'
        open={filterDrawerOpen}
        footer={false}
        onClose={closeFilterDrawer}
        title={<p className='mb-0 subhead-3'>Filter Transaction</p>}
        closeIcon={<CloseIcon />}
        width='100%'
      >
        <Form className='filter-form' form={form}>
          <div className='filter-fields'>
            <TransactionListFilter
              filterValue={transactionType}
              action={(val) => handleTransactionTypeFilter(val)}
              defaultValue={transactionsType ? 'Dividend' : transactionType}
              label={'Transaction type'}
              filterType={'transactionType'}
            />
            <TransactionListFilter filterValue={timePeriod} action={handleTimePeriodFilter} label={'Time period'} filterType={'timePeriod'} />
            <TransactionListFilter
              defaultValue={shareType}
              filterValue={shareType}
              action={handleShareTypeFilter}
              label={'Share type'}
              filterType={'shareType'}
            />
          </div>
          <Button type='primary' className='w-100' onClick={handleDrawerFilter}>
            Apply Filters
          </Button>
        </Form>
      </Drawer>
      {transferModal && (
        <InitiateTransferModal
          isTransferModalOpen={transferModal}
          closeTransferModal={() => setTransferModal()}
          openTransferCompleteModal={setTransferCompleteModal}
          initiateTransferedData={setInitiateTransferedData}
          openTransection={openTransection}
        />
      )}
      {transferCompleteModal && (
        <TransferCompleteModal
          transferCompleteModal={transferCompleteModal}
          setTransferCompleteModal={() => setTransferCompleteModal()}
          setTransactionDetailsOpen={() => setTransactionDetailsOpen()}
          openInitiateTransfer={() => setTransferModal(true)}
          initiateTransferedData={initiateTransferedData}
        />
      )}
      {transactionDetailsOpen && (
        <TransactionDetailsModal
          transactionDetailsOpen={transactionDetailsOpen}
          setTransactionDetailsOpen={() => setTransactionDetailsOpen()}
          modalTransactionData={pendingModalTransactionData}
        />
      )}
      {scheduledOpen && (
        <ScheduledTransactionModal
          scheduledOpen={scheduledOpen}
          setScheduledOpen={setScheduledOpen}
          modalTransactionData={scheduledModalTransactionData}
          handlecancelTransfer={() => handlecancelTransfer()}
          loading={cancelOrderLoading}
        />
      )}
      <BankAccountModal
        bankModalOpen={bankModalOpen}
        setBankModalOpen={(value) => setBankModalOpen(value)}
        onSuccess={() => handleBankAddSuccess()}
      />
    </div>
  );
};

export default Transaction;
